/* ==========================================================================
   HAUSS CARE - DAR helpers del carrito CMX (Broadcast 6.1.0)
   Origen: biblioteca DAR cmx-mini-cart-kalles (assets/naturale-dar.js, 2026-10-15), adaptado.
   Cambios vs biblioteca:
   - NM -> HC, NMConfig -> HCConfig, propiedad del regalo `_hc_regalo`, marca `?hc_gift=1`.
   - tierState(cart): el nivel de envio se mide con cart.total_price (despues de descuentos, como la
     condicion de la tarifa "Gratis" de Shopify); regalo y descuentos se miden con tierBase.
   - Tras cambiar el regalo pide a Broadcast reconstruir su carrito ('theme:cart:refresh') en vez de
     recargar la pagina. Sin reveal ni carruseles de Naturale.
   Pixel-safe: solo lee /cart.js. La unica escritura es el regalo de $0 (agrega o quita 1 pieza), igual
   que hacia el nivel "Regalo Gratis" de Rebuy.
   Depende de: window.HCConfig (sections/hc-mini-cart.liquid).
   ========================================================================== */
(function () {
  if (window.HC) return;
  var cfg = window.HCConfig || {};

  function fmtNumber(cents, decimals, thousands, decimal) {
    var n = (Number(cents) || 0) / 100;
    var fixed = n.toFixed(decimals);
    var parts = fixed.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
    return parts.length > 1 ? parts[0] + decimal + parts[1] : parts[0];
  }

  function formatMoney(cents) {
    var format = cfg.moneyFormat || '${{amount}}';
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      switch (key) {
        case 'amount_no_decimals': return fmtNumber(cents, 0, ',', '.');
        case 'amount_with_comma_separator': return fmtNumber(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return fmtNumber(cents, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return fmtNumber(cents, 2, "'", '.');
        default: return fmtNumber(cents, 2, ',', '.');
      }
    });
  }

  function getCart() {
    return fetch((cfg.cartUrl || '/cart') + '.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); });
  }

  // Linea de regalo: la que agrega este carrito (propiedad oculta) o la variante de regalo a $0
  function isGift(it) {
    if (!it) return false;
    if (it.properties && it.properties._hc_regalo) return true;
    return !!(cfg.gift && it.variant_id === cfg.gift.variantId && it.final_line_price === 0);
  }
  // Base de los niveles = subtotal despues de descuentos por producto y antes del descuento del pedido,
  // sin el regalo. Es el subtotal que usa Shopify para el minimo de compra de sus descuentos.
  function tierBase(cart) {
    return (cart.items || []).reduce(function (s, it) { return s + (isGift(it) ? 0 : (it.final_line_price || 0)); }, 0);
  }
  // Regalo automatico: agrega 1 cuando la base llega al minimo y lo quita si baja.
  // Devuelve una promesa con true si cambio el carrito.
  var giftBusy = false, giftChangedAt = 0;
  function syncGift(cart) {
    var g = cfg.gift;
    if (!g || !g.variantId || giftBusy || !cart) return Promise.resolve(false);
    // Un carrito leido justo despues de cambiar el regalo puede venir desactualizado: no se vuelve a tocar
    if (Date.now() - giftChangedAt < 1500) return Promise.resolve(false);
    var lines = (cart.items || []).filter(function (it) { return it.variant_id === g.variantId; });
    var qty = lines.reduce(function (s, it) { return s + it.quantity; }, 0);
    var wants = tierBase(cart) >= g.min ? 1 : 0;
    if (qty === wants) return Promise.resolve(false);
    giftBusy = true;
    var root = (cfg.rootUrl || '/').replace(/\/$/, '');
    var req;
    if (wants && !qty) {
      req = fetch(root + '/cart/add.js?hc_gift=1', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: g.variantId, quantity: 1, properties: { _hc_regalo: '1' } }] }) });
    } else {
      var updates = {};
      lines.forEach(function (it, i) { updates[it.key] = wants && i === 0 ? 1 : 0; });
      req = fetch(root + '/cart/update.js?hc_gift=1', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ updates: updates }) });
    }
    return req.then(function (r) { giftBusy = false; if (r.ok) giftChangedAt = Date.now(); return r.ok; }).catch(function () { giftBusy = false; return false; });
  }

  // Niveles: { kind: 'gift' | 'ship' | 'discount', amount (centavos), label, short }
  function tierState(cart) {
    var base = tierBase(cart);
    var shipBase = Math.min(base, (cart && cart.total_price) || 0);
    var tiers = (cfg.tiers || []).slice().sort(function (a, b) { return a.amount - b.amount; });
    function value(t) { return t.kind === 'ship' ? shipBase : base; }
    var reached = null, next = null, missing = 0;
    tiers.forEach(function (t) {
      if (value(t) >= t.amount) reached = t;
      else if (!next) { next = t; missing = t.amount - value(t); }
    });
    return { tiers: tiers, base: base, reached: reached, next: next, missing: missing, hit: function (t) { return value(t) >= t.amount; } };
  }

  function escapeHtml(s) {
    var d = document.createElement('div');
    d.appendChild(document.createTextNode(s == null ? '' : String(s)));
    return d.innerHTML;
  }

  // Pide a Broadcast reconstruir su carrito (contador del header, drawer nativo oculto y pagina /cart)
  function refreshTheme() {
    document.dispatchEvent(new CustomEvent('theme:cart:refresh', { bubbles: true }));
  }

  window.HC = {
    config: cfg,
    formatMoney: formatMoney,
    getCart: getCart,
    tierState: tierState,
    tierBase: tierBase,
    isGift: isGift,
    syncGift: syncGift,
    escapeHtml: escapeHtml,
    refreshTheme: refreshTheme
  };

  // Mantener el regalo al dia aunque el carrito cambie fuera del CMX (pagina /cart, otra pestana)
  function giftCheck() {
    if (!cfg.gift) return;
    // Con el CMX abierto, su render ya sincroniza el regalo; y tras un cambio se espera 2 s (evita la carrera
    // entre dos lecturas de /cart.js que pedia el regalo dos veces)
    var d = document.getElementById('cmx-drawer');
    if ((d && d.classList.contains('is-open')) || Date.now() - giftChangedAt < 2000) return;
    getCart().then(syncGift).then(function (changed) {
      if (!changed) return;
      refreshTheme();
      if (window.hcCart) window.hcCart.refresh();
    }).catch(function () {});
  }
  var tChange = null;
  document.addEventListener('theme:cart:change', function () { clearTimeout(tChange); tChange = setTimeout(giftCheck, 150); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', giftCheck);
  else giftCheck();
})();
